$(document).ready(function ($) {
  "use strict"; 
  function megaMenu() {
    if($('.default_dropdown').length > 0 ) {
    if ($("#header .page-full-width").length) {
      var parentRow = $("#header .page-full-width > .row");
      var parentLeft = parseInt(parentRow.css("marginLeft").replace("px", ""));
    } else {
      var parentRow = $("#header .page-width .row");
      var parentLeft = parseInt(parentRow.offset().left);
    }
    var parentWidth = parentRow.width();

    $("#header .dt-nav li:not(.close-nav)").each(function () {
      var thisItem = $(this);
      if (thisItem.hasClass("menu-item-has-children")) {
        var thisItemLeft = thisItem.find(".megamenu_megamenu > a").offset().left;
        var menuLeft = parseInt(thisItemLeft - parentLeft);
        thisItem.find(".sub-menu-block").css("width", parentWidth);
       }
    });

    $("sticky-header .dt-nav li:not(.close-nav)").each(function () {
      var thisItem = $(this);
      if (thisItem.hasClass("menu-item-has-children")) {
        var thisItemLeft = thisItem.find(".megamenu_megamenu > a").offset().left;
        var menuLeft = parseInt(thisItemLeft - parentLeft);        
        thisItem.find(".sub-menu-block").css("width", parentWidth);      
      }
    });
    window.setTimeout(function () {
      $(window).trigger("resize");
    }, 800);

    }
  }
  var megaMenuResize = false;
  $(window).bind("resize", function () {
    if (!megaMenuResize) {
      megaMenu();
      megaMenuResize = true;
    }
  });
  megaMenu();
});

$(function () {
  if ($(window).width() >= 1200) {
    $(".deskTabs a").click(function () {
      let id = $(this).attr("href");
      $(".deskTabs li").removeClass("active");
      $(this).parent().addClass("active");
      $(this).parent().parent().parent().parent().addClass("active");
      $(".tabs-content li.dt-sc-menu-tabs").hide();
      $(this).parent().parent().parent().parent().find(id).show();

      return false;
    });
  }
  if ($(window).width() <= 1199) {
    $(".mobileTabs .tabs  li").each(function () {
      $(this).click(function () {
        $(this).next("div").slideToggle(0);
      });
    });
  }
});
$(document).ready(function () {
  $("#category-menu-button").click(function () {
    $(this).toggleClass("open");
    $(".category-wrapper").toggleClass("open");
    $(".category-wrapper").slideToggle(0);
  });
});
// ===== Mobile Mega Menu Fix v2 =====
(function () {
  function isMobile() {
    return window.innerWidth < 990;
  }

  function initMobileMegaMenu() {
    if (!isMobile()) return;

    // Target links inside the mobile drawer only
    var navLinks = document.querySelectorAll(
      '.menu-drawer .subMenuBlock > .megamenu_megamenu > a.dt-sc-nav-link'
    );

    navLinks.forEach(function (link) {
      // Avoid adding duplicate listeners
      if (link.dataset.mobileFixed) return;
      link.dataset.mobileFixed = 'true';

      link.addEventListener('click', function (e) {
        var parentLi = this.closest('.subMenuBlock');
        if (!parentLi) return;

        var subMenu = parentLi.querySelector(':scope > .megamenu_megamenu > .sub-menu-block');
        if (!subMenu) return;

        e.preventDefault();
        e.stopPropagation();

        var isOpen = parentLi.classList.contains('mobile-open');

        // Close all siblings
        var allItems = document.querySelectorAll('.menu-drawer .subMenuBlock.mobile-open');
        allItems.forEach(function (el) {
          el.classList.remove('mobile-open');
          var s = el.querySelector(':scope > .megamenu_megamenu > .sub-menu-block');
          if (s) s.classList.remove('mobile-open');
        });

        // Toggle current
        if (!isOpen) {
          parentLi.classList.add('mobile-open');
          subMenu.classList.add('mobile-open');
        }
      });
    });
  }

  // Watch for the mobile drawer opening (it uses <details> element)
  document.addEventListener('click', function (e) {
    var drawerTrigger = e.target.closest(
      '.header__icon--menu, [data-drawer-toggle], summary.menu-drawer__menu-item'
    );
    if (drawerTrigger) {
      setTimeout(initMobileMegaMenu, 400);
    }
  });

  // Also run on DOMContentLoaded as fallback
  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(initMobileMegaMenu, 500);
  });
})();
